import { BaseEntity } from '@base-entities';
import { NotificationTransformer } from '../transformers';
import { IBaseTransformerRepository } from '@base-repositories';

export function makeNotificationTransformer<E extends BaseEntity = BaseEntity>(): IBaseTransformerRepository<E> {
  return new NotificationTransformer<E>();
}
